module.exports = __webpack_public_path__ + "img/lunbo3.50c9aa0d.jpg";